import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { OperatorsService } from '../operators.service';

@Component({
  selector: 'app-new-operator',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './new-operator.component.html',
  styleUrl: './new-operator.component.css',
})
export class NewOperatorComponent {
  private readonly operatorsService = inject(OperatorsService);
  private readonly router = inject(Router);

  operatorName = signal('');
  operatorEmail = signal('');
  loading = signal(false);
  error = signal<string | null>(null);
  success = signal(false);

  async createOperator() {
    const displayName = this.operatorName().trim();
    const email = this.operatorEmail().trim();

    // Validation
    if (!displayName || !email) {
      this.error.set('Please fill in all fields');
      return;
    }

    if (!this.operatorsService.isValidEmail(email)) {
      this.error.set('Please enter a valid email address');
      return;
    }

    this.loading.set(true);
    this.error.set(null);

    const result = await this.operatorsService.createOperator({ displayName, email });

    if (result.success) {
      this.success.set(true);
      setTimeout(() => this.router.navigate(['/main/operators']), 2000);
    } else {
      this.error.set(result.error ?? 'Failed to create operator');
    }

    this.loading.set(false);
  }

  cancel() {
    this.router.navigate(['/main/operators']);
  }
}
